module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alti-winds-view"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topAltitude),
      expression: "topAltitude"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.topAltitude = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("10000")]), _vm._v(" "), _c('option', [_vm._v("8000")]), _vm._v(" "), _c('option', [_vm._v("6000")]), _vm._v(" "), _c('option', [_vm._v("4000")]), _vm._v(" "), _c('option', [_vm._v("2000")])]), _vm._v(" "), _c('canvas', {
    ref: "scale",
    attrs: {
      "id": "scale"
    }
  }), _vm._v(" "), _c('div', {
    ref: "scrollable",
    staticClass: "scrollable"
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "id": "canvas"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader middle"
  }, [_c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data === 'no-data'),
      expression: "data === 'no-data'"
    }],
    staticClass: "no-data"
  }, [_c('div', {
    staticClass: "middle"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "windgram view"
    }
  }, [_vm._v("No data for this place")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('i', {
    staticClass: "fa fa-frown-o"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76dc7af6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alti-winds-view.vue
// module id = 343
// module chunks = 1